import { Alert, Button } from '@mui/material';
import { googleLogout } from '@react-oauth/google';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useConnection from '../../hooks/project/useConnection';
import { setProfile } from '../../states/login/loginSlice';

const ConnectionExpired = () => {
  const system = useSelector((state) => state?.static?.system);
  const [displayAlert, setDisplayAlert] = useState(false);
  const [isEnableSWR, setIsEnableSWR] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [timeoutID, setTimeoutID] = useState(null);

  const profile = useSelector((state) => state?.login?.profile);
  const { _data, error } = useConnection(profile?._id);

  useEffect(() => {
    if (import.meta.env.VITE_NODE_ENV === 'local') {
      return;
    }
    if (isEnableSWR) {
      if (error) {
        setIsEnableSWR(false);
        setDisplayAlert(true);
        setTimeoutID(
          setTimeout(() => {
            googleLogout();
            dispatch(setProfile(null));
            navigate('/login');
          }, 60000)
        );
      }
    }
    setIsEnableSWR(true);
  }, [error]);

  useEffect(() => {
    const isSuperAdmin = profile.roles.some(
      (role) => role.name === 'Super-Administrateur'
    )
      ? true
      : false;
    if (system?.status?.code === 'DEPLOYING' && !isSuperAdmin) {
      googleLogout();
      dispatch(setProfile(null));
      navigate('/login');
    }
  }, [system]);

  return (
    <>
      {displayAlert && (
        <Alert
          variant="filled"
          severity="warning"
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                clearTimeout(timeoutID);
                setTimeoutID(null);
                googleLogout();
                dispatch(setProfile(null));
                navigate('/login');
              }}
            >
              OK
            </Button>
          }
        >
          Connection expirée. Vous allez être déconnecté dans 60 secondes.
        </Alert>
      )}
    </>
  );
};

export default ConnectionExpired;
